/**
 * 回收站
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

import BaseComponent from "../../../../base/BaseComponent";
import {Table, Input, Checkbox, Button, Tabs, Modal, Pagination} from "antd";
import '../../components/TableList.css'
import Position from '../../components/Position'
import {formatTime, changeSize} from "../../../../utils";
import {message} from '../../components/Mess'
import PageTableComponent from "../../components/pageTable/PageTable";
import {HEADER_HEIGHT} from "../../../../constants";
import Detailpage from "../../components/DetailPage";
import {Scrollbars} from "react-custom-scrollbars";
import $ from "jquery";

const {Search} = Input;
const {TabPane} = Tabs;
const {confirm} = Modal;

export default class TransferList extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {

        super(props);
        this.state = {
            searchText: '',//搜索的文字
            page: 1,
            size: 10,
            data:[],
            selectedRowKeys:[],
            selectedRows:[]

        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getList()
    }
    render() {
        let height = document.body.clientHeight - HEADER_HEIGHT - 32 ;
        return (
            <div style={{background: '#ffffff', padding: '24px 15px',  margin: "15px 0 15px 15px",borderRadius:5, height: height}}>
                {this.renderBtn()}
                {/*渲染数据*/}
                {this.renderData()}
            </div>
        )
    }

    renderBtn() {
        return (
            <div style={{display: 'flex'}}>

                    <Button  style={{marginRight: 15}} icon={"delete"}
                            onClick={() => {
                                this.allDelete()
                            }}
                    >删除
                    </Button>
                    <Search
                        placeholder="请输入名称"
                        allowClear={true}
                        value={this.state.searchText}
                        onSearch={value => {
                            this.setState({searchText: value,page:1}, () => {
                                this.getList()
                            })
                        }}
                        onChange={(e) => {
                            this.setState({searchText: e.target.value})
                        }}
                        style={{width: 224}}
                    />
            </div>
        )
    }

    renderData() {
        let  columns=[
            {
                title: '名称',
                dataIndex: 'name',
                width:600,
                ellipsis: true,
                render: (text, record) =>{
                    let title=text;
                    return (<div style={{display:'flex'}} title={'text'}>
                        {/*<div>*/}
                        {/*    <img src={record.icon} style={{width:'24px',height:'24px',objectFit: "contain"}}/>*/}
                        {/*</div>*/}
                        <div>
                            <div
                                title={title}
                                style={{ color: "rgba(0, 0, 0, 0.85)",
                                    width:580,overflow:'hidden',whiteSpace:'nowrap',
                                    textOverflow:'ellipsis',
                                    fontSize: "16px",marginLeft:'8px'}}>{text}</div>
                        </div>
                    </div>)
                }
            },

            {
                title: '大小',
                dataIndex: 'size',

                render: (text, record) => {
                    return (<div>{text>0?changeSize(text):0+'b'}</div>)
                }
            },
            {
                title: '上传状态',
                dataIndex: 'statusName',
            },
            {
                title: '操作',
                align:'center',
                dataIndex: 'address',
                render: (text, record) =>{
                    let size =record.size;
                    return (<span style={{cursor:"pointer",color:'#0050B3'}} onClick={()=>{this.delete(record)}}>删除</span>)
                }},
        ];
        const {selectedRowKeys} = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.state.selectedRowKeys = selectedRowKeys;
                this.state.selectedRows = selectedRows;
                this.setState({}, () => {

                })
            },
        };
        return (
            <div>
                <PageTableComponent
                    columns={columns}
                    rowSelection={rowSelection}
                    data={this.state.data}
                    page={this.state.page}
                    size={this.state.size}
                    count={this.state.count}
                    onChangePage={(page, size) => {
                        this.onChangePage(page, size)
                    }}
                ></PageTableComponent>
                <Detailpage onRef={(Detailpage) => this.setDetailpage = Detailpage}
                            dataList={this.state.data}></Detailpage>
            </div>

        )
    }

    //翻页
    onChangePage(page, size) {
        this.setState({page: page, size: size,selectedRowKeys:[], selectedRows:[]}, () => {
            this.getList()
        })
    }
    //删除选中的
    allDelete() {
        let {selectedRows} =this.state;
        let ids = [];
        selectedRows&&selectedRows.length&&selectedRows.forEach((item,index)=>{
            ids.push(item.uid)
        });
        if(ids&&ids.length){
            confirm({
                title: '回收站内的所有文件将无法恢复，您确认要清空回收站？',
                onOk: () => {
                    this.request({
                        url: "/cm-sites-storage-management/upload/deleteByUids",
                        method: "get",
                        body: {"uids":ids.join(',')},
                        callBack: (data) => {
                            if (data) {
                                this.getList()
                            }
                        }
                    });
                },
                onCancel() {
                },
            });
        }else{
            message.destroy();
            message.warning('请至少选择一个文件')
        }

    }

// 获取列表
    getList() {
        let url = "/cm-sites-storage-management/upload/pageList";
        let parms = {
            page: this.state.page,
            size: this.state.size,
            name: this.state.searchText,
        };
        this.request({
            url: url,
            method: "post",
            body: parms,
            contentType: "json",
            callBack: (data) => {
                if (data) {
                    this.setState({data: data.data, count: data.count});
                    $('.ant-pagination-options-quick-jumper').find('input').val('')
                }
            }
        });
    }
    //彻底删除
    delete(record) {
        confirm({
            title: '文件删除后将无法恢复，您确认要彻底删除所选文件？',
            onOk: () => {
                this.request({
                    url: "/cm-sites-storage-management/upload/delete",
                    method: "get",
                    body: {uid:record.uid},
                    contentType: "json",
                    callBack: (data) => {
                        this.getList()
                    }
                });
            },
            onCancel() {
            },
        });
    }
}